module.exports = __webpack_public_path__ + "static/donate_company_logo01@2x-77b2aaa53888a41a0377d9ce13091469.png";